import { defineQuery } from '@pinia/colada'
import { STALE_TIME } from '@rialtic/utils'

export type Auth0User = {
  user_id: string
  email?: string
  picture?: string
  given_name?: string
  family_name?: string
  name?: string
  groups?: string[]
  logins_count?: number
  last_login?: string
  app_metadata?: {
    privacy_policies?: boolean
    privacy_policies_timestamp?: number
  }
}

export type Auth0UsersResponse = { result: Auth0User[] }

export type SlackUser = {
  email?: string
  avatar?: string
}

const USER_QUERY_KEYS = {
  root: ['users'] as const,
  auth0Users: () => [...USER_QUERY_KEYS.root, 'auth0', 'users'] as const,
  slackUsers: () => [...USER_QUERY_KEYS.root, 'slack', 'users'] as const,
  slackUsersByEmails: (emails: string[]) =>
    [
      ...USER_QUERY_KEYS.root,
      'slack',
      emails.reduce((acc, email) => ({ ...acc, [email]: true }), {}),
    ] as const,
  slackUserById: (id: string) =>
    [...USER_QUERY_KEYS.root, 'slack', id] as const,
}

export const useAuth0Users = defineQuery({
  key: USER_QUERY_KEYS.auth0Users(),
  query: () => {
    const client = useRequestFetch()
    return client<Auth0UsersResponse>('/api/auth0/users')
  },
  staleTime: STALE_TIME.FIVE_MINUTES,
})

export const useSlackUsers = defineQuery({
  key: USER_QUERY_KEYS.slackUsers(),
  query: () => {
    const client = useRequestFetch()
    return client<SlackUser[]>('/api/slack/users')
  },
  staleTime: STALE_TIME.FIVE_MINUTES,
})
